import { Injectable } from '@angular/core';
import { Act48Api } from '../api/act48.api';
import { CplA48SubmissionDetail } from '../model/cpl-a48-submission-detail.model';
import { CplA48UserSubmissionDetail } from '../model/a48/cpl-a48-user-submission-detail.model';

@Injectable()
export class Act48Service {
    constructor(private act48Api: Act48Api) {}

    getAct48UserSubmissionDetails = (TypeId: number, Type: number) => this.act48Api.getAct48UserSubmissionDetails(TypeId, Type);

    getAct48Status = (userCycleId: string) => this.act48Api.getAct48Status(userCycleId);

    ResubmitAct48Submission = (details: CplA48SubmissionDetail) => this.act48Api.ResubmitAct48Submission(details);

    ResubmitAct48UserSubmission = (details: CplA48UserSubmissionDetail) => this.act48Api.ResubmitAct48UserSubmission(details);

    OverrideAct48Submission = (details: CplA48SubmissionDetail) => this.act48Api.OverrideAct48Submission(details);

    SaveUserSubmissionDetails = (value: CplA48UserSubmissionDetail) => this.act48Api.SaveUserSubmissionDetails(value);

    getParaErrorSummary = (userId: string, offset: number, limit: number, orderBy: string, ascending: boolean, searchBy?: string, updateStatusCounts:boolean=true) =>
        this.act48Api.getParaErrorSummary(userId, offset, limit, orderBy, ascending, searchBy);

    getAct48HoursDetailsReport = (requestID: string) => this.act48Api.getAct48HoursDetailsReport(requestID);
}